"use client";

import { useReactiveVar } from "@apollo/client";
import type { User } from "@shared/utils.user";
import { BPUser, guestUser, userVar } from "lib/user";
import { useEffect, useState } from "react";

/**
 * This hook helps with server-side rendering (SSR) hydration issues.
 * It initially renders a guest user to synchronize the initial HTML on both server and client.
 */
type UserV2 = User & { loading: boolean };

export function useUserV2(): UserV2 {
  const [user, setUserValue] = useState<UserV2>({
    ...BPUser(guestUser),
    loading: true
  }); // initial user is always guest

  const reactiveUser = useReactiveVar(userVar); // get the actual user

  useEffect(() => {
    setUserValue({ ...reactiveUser, loading: false }); // this will do a second render with the actual user
  }, [reactiveUser]);

  return user;
}
